/*global location */
/*global env */

(function() {
    angular
        .module('emarket.commons')
        .factory('ErrorInterceptor', ['$log', '$rootScope', '$location', '$q', '$injector', '$timeout', function($log, $rootScope, $location, $q, $injector, $timeout) {
            var pendingRequests = 0;
            var updateLink = function updateLink() {
                $timeout(function() {
                    if (location.protocol === 'http:' && env === 'production') {
                        $('a[ui-sref]').each(function(i, element) {
                            var ref = $(element).attr('href');
                            if (/http/.test(ref) || /tel/.test(ref)) {
                                return;
                            }
                            ref = 'https://emarket.do/' + ref;
                            var newElement = element.cloneNode(true);
                            $(newElement).attr('href', ref);
                            element.parentNode.replaceChild(newElement, element);
                        });
                    }
                }, 500);
            };
            return {
                responseError: function(config) {
                    var $mdToast = $injector.get('$mdToast');
                    if (config.status !== 401) {
                        var message = config.data.message
                            ? config.data.message
                            : 'Lo sentimos, esta la operacion no pudo ser completada';
                        var toast = $mdToast.simple().textContent(message);
                        $mdToast.show(toast);
                    }
                    return $q.reject(config);
                }
            };
        }]);
}());
